import script from "./MediaInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaInfo.vue?vue&type=script&setup=true&lang=js"

import "./MediaInfo.vue?vue&type=style&index=0&id=564e300e&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564e300e"]])

export default __exports__